module.exports = __webpack_public_path__ + "6e0684badfe27a7d0fed276bf16674db.svg";